import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Maps route paths to readable titles
const routeTitles = {
  '/': 'Home',
  '/signup': 'Sign Up',
  '/login': 'Login',
  '/forgot-password': 'Forgot Password',
  '/dashboard': 'Dashboard',
  '/learn-more': 'Learn More',
  '/tribes': 'Explore Tribes',
  '/tribes/create': 'Create Tribe',
  '/profile': 'Profile',
  '/explore': 'Explore People',
  '/project-matchmaking': 'Project Matchmaking',
  '/project-matchmaking/:projectId': 'Project Details',
};

const PageTitle = () => {
  const location = useLocation();
  
  useEffect(() => {
    const getTitle = (pathname) => {
      // Check exact paths first
      if (routeTitles[pathname]) {
        return routeTitles[pathname];
      }
      
      // Handle dynamic routes
      if (pathname.startsWith('/tribes/') && pathname !== '/tribes/create') {
        return 'Tribe Details';
      }
      
      if (pathname.startsWith('/profile/')) {
        return 'User Profile';
      }
      
      // Default fallback
      return 'SyntaxSocial';
    };
    
    // Get the title based on the current path
    const title = getTitle(location.pathname);
    
    // Set the document title with format "Page | SyntaxSocial"
    document.title = title === 'SyntaxSocial' ? title : `${title} | SyntaxSocial`;
    
    // Clean up function (optional)
    return () => {
      // Reset title on unmount if needed
    };
  }, [location]);
  
  // This component doesn't render anything visible
  return null;
};

export default PageTitle; 